export const BRAND = "#0f6b62";
export const BRAND_DARK = "#0a4f48";
export const BRAND_SOFT = "#e7f2f0";
export const ACCENT = "#0d9488";
export const TEXT_PRIMARY = "#1f2937";
export const TEXT_SECONDARY = "#6b7280";
export const BORDER = "rgba(0,0,0,0.08)";

export const MAX_FILE_SIZE_BYTES = 50 * 1024 * 1024;
export const MAX_PAGES = 20;

export const VERSIONS = {
  previous: {
    key: "previous",
    label: "גרסה קודמת",
    hint: "הקובץ שנשלח לתיקונים",
    color: "#64748b",
    bg: "#f1f5f9",
  },
  updated: {
    key: "updated",
    label: "גרסה מעודכנת",
    hint: "הקובץ שהתקבל לאחר התיקונים",
    color: ACCENT,
    bg: "#f0fdfa",
  },
};

export const CHECK_STATUSES = {
  uploaded: { label: "ממתינה לעיבוד", color: "#b45309", bg: "#fffbeb" },
  extracting: { label: "חילוץ טקסט", color: BRAND, bg: BRAND_SOFT },
  extracted: { label: "ממתינה להשוואה", color: "#7c3aed", bg: "#f5f3ff" },
  comparing: { label: "השוואה", color: BRAND, bg: BRAND_SOFT },
  compared: { label: "השוואה הושלמה", color: "#0d9488", bg: "#f0fdfa" },
  controlling: { label: "בקרת תיקונים", color: BRAND, bg: BRAND_SOFT },
  reporting: { label: "הפקת דוח", color: BRAND, bg: BRAND_SOFT },
  completed: { label: "הושלמה", color: "#15803d", bg: "#f0fdf4" },
  failed: { label: "נכשלה", color: "#b91c1c", bg: "#fef2f2" },
};

export const SEVERITIES = [
  { key: "critical", label: "קריטי", color: "#b91c1c", bg: "#fef2f2" },
  { key: "medium", label: "בינוני", color: "#e07a00", bg: "#fff4e5" },
  { key: "low", label: "נמוך", color: "#2563eb", bg: "#eff6ff" },
];

// Corrections control statuses (spec 3.4)
export const CORRECTION_STATUSES = {
  done: { label: "בוצע", color: "#15803d", bg: "#f0fdf4", bar: "#22c55e" },
  partially_done: { label: "בוצע חלקית", color: "#b45309", bg: "#fffbeb", bar: "#f59e0b" },
  not_done: { label: "לא בוצע", color: "#b91c1c", bg: "#fef2f2", bar: "#ef4444" },
  needs_review: { label: "דורש הכרעה", color: "#6d28d9", bg: "#f5f3ff", bar: "#8b5cf6" },
};
export const CORRECTION_STATUS_ORDER = ["not_done", "partially_done", "needs_review", "done"];

export const formatFileSize = (bytes) => {
  if (!bytes && bytes !== 0) return "";
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};

export const formatDateTime = (value) =>
  new Date(value).toLocaleString("he-IL", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
